<template>
  <v-app>
    <div>
      <div class="text-xs-center">
        <v-btn color="primary" @click="state = !state">Toggle</v-btn>
      </div>
      <v-alert
        color="success"
        :value="state"
        transition="scale-transition"
      >
        Whoops! An error occured!
      </v-alert>
    </div>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      state : false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ToggleBtn.vue